import React, { useState, useEffect, useRef } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { Alterar, Excluir, Visualizar, BtnAcaoLink, BtnAcaoModal, BtnAcao, BtnAcaoConfirmacao, Btn } from '../../../../components/Acoes'
import { Link } from 'react-router-dom'
import { get, excluir, salvar, put, obterInstancia } from '../../../../util/AcessoApi'
import { ACOES } from '../../../../util/Enums'
import { getUsuario, URL_BACKEND } from '../../../../util/Configuracoes'
import { mostrarToast } from '../../../../components/Toasts'
import { mensagens, obterCorStatusDevolucao } from '../../../../util/Utilitarios.js'
import { CadastroModalDevolucao, CadastroCancelamentoDevolucao } from './CadastroModal'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import { ModalDuasOpcoes } from '../../../../components/Modais.js'
import { toast } from 'react-toastify';


export default props => {
    const [data, setData] = useState([])
    const target = useRef(null)
    const [showModal, setShowModal] = useState(false)
    const [showModalCancelamento, setShowModalCancelamento] = useState(false)
    const [showValidacao, setShowValidacao] = useState(false)
    const [msgValidacao, setMsgValidacao] = useState('')
    const [linhaConsulta, setLinhaConsulta] = useState(null)
    const columns = React.useMemo(
        () => [
            {
                id: 'consulta-devolucao',
                columns: [
                    {
                        Header: 'Código',
                        accessor: 'id',
                        html: item => {
                            return (
                                <>
                                    <span className='display-flex'>
                                        <OverlayTrigger
                                            trigger={["hover", "focus"]}
                                            placement={"bottom"}
                                            onToggle={() => props.onToggle && props.onToggle()}
                                            target={`popover-positioned-${props.id}`}
                                            overlay={
                                                <Popover id={`popover-positioned-${props.id}`}>
                                                    <Popover.Title as="h3">Status</Popover.Title>
                                                    <Popover.Content>
                                                        {item.status_descricao}
                                                    </Popover.Content>
                                                </Popover>
                                            }
                                        >
                                            <span className='status-lancamento' style={{ background: obterCorStatusDevolucao(item.status_id) }}></span>
                                        </OverlayTrigger>
                                        <span style={{ marginTop: 8 }}> {item.id}</span>
                                    </span>
                                </>
                            )
                        },
                        ordenamento: {
                            tipo: 'numero',
                            ativo: true,
                            modo: 'desc',
                        }
                    },
                    {
                        Header: 'Cooperado',
                        accessor: 'cooperado',
                        ordenamento: {
                            tipo: 'texto'
                        },
                        filtro: {
                            combo: 'combo-simples',
                            idColuna: 'cooperado',
                            tipo: 'cooperado',
                            completo: true
                        }
                    },
                    {
                        Header: 'Quantidade Comprovante',
                        accessor: 'quantidade',
                        ordenamento: {
                            tipo: 'texto'
                        }
                    },
                    {
                        Header: 'Devolvido?',
                        accessor: 'devolvido',
                        ordenamento: {
                            tipo: 'texto'
                        },
                        filtro: {
                            combo: 'combo-simples',
                            idColuna: 'devolvido_bool',
                            tipo: 'devolvido',
                            multiplo: false
                        }
                    },
                    {
                        Header: 'Data Devolução',
                        accessor: 'data_devolucao',
                        ordenamento: {
                            tipo: 'data'
                        }
                    },
                    {
                        Header: 'Data Devolução Inicial',
                        accessor: 'data_devolucao_inicial',
                        ordenamento: {
                            tipo: 'data',
                        },
                        visivel: false,
                        filtro: {
                            tipo: 'data_inicial',
                            idColuna: 'data_devolucao_inicial'
                        }
                    },
                    {
                        Header: 'Data Devolução Final',
                        accessor: 'data_devolucao_final',
                        ordenamento: {
                            tipo: 'data',
                        },
                        visivel: false,
                        filtro: {
                            tipo: 'data_final',
                            idColuna: 'data_devolucao_final'
                        }
                    },
                    {
                        Header: 'Nome Responsável',
                        accessor: 'responsavel',
                        ordenamento: {
                            tipo: 'texto'
                        }
                    }, {
                        Header: 'Data Registro',
                        accessor: 'data_registro',
                        ordenamento: {
                            tipo: 'texto'
                        }
                    },
                    {
                        Header: 'Status',
                        accessor: 'status_id',
                        visivel: false,
                        filtro: {
                            tipo: 'devolucao_status',
                            idColuna: 'status_id'
                        }
                    },
                ],

            },

        ],
        []
    )

    const exclusao = propsAcao => {
        const objPermissao = {
            usuario_id: getUsuario().id,
            modulo_id: props.modulo,
            acao_id: ACOES.EXCLUIR
        }

        get('/controleAcesso/permissao', objPermissao).then(function (val) {
            if (val.length)
                excluir('/devolucao/lote', propsAcao.id,
                    () => {
                        target.current.atualizar();
                        mostrarToast('sucesso', mensagens['sucesso'])
                    },
                    (e) => {
                        if (e.response && e.response.data && e.response.data.erros)
                            e.response.data.erros.forEach((item) => mostrarToast('erro', item))
                        else
                            mostrarToast('erro', mensagens.erro)
                    })
            else
                mostrarToast('erro', mensagens['permissao'])

        }).catch((e) => mostrarToast('erro', mensagens['erro']))
    }

    const validarDevolucaoLote = async (linha, setLoadingAct) => {
        setLoadingAct(true)
        Promise.resolve(put(`/devolucao/validarenvioemail`, {
            copf_id: linha.copf_id,
            copj_id: linha.copj_id
        }, true, true)).then(x => {
            enviarDevolucao(linha, setLoadingAct)


        }).catch(e => {
            const tipoErro = e.response?.data?.type || "GENERIC";

            if (tipoErro === 'EMAIL_NAO_CADASTRADO') {
                setMsgValidacao(e.response?.data?.message || e.message)
                setShowValidacao(true)
            }
        })
        setLoadingAct(false)

    }

    const enviarDevolucao = async (linha, setLoadingAct) => {

        mostrarToast(undefined, <span>Enviando lote: <b>{linha.id}</b></span>);
        Promise.resolve(put(`/devolucao/enviarLote`, {
            id: linha.id,
            copf_id: linha.copf_id,
            copj_id: linha.copj_id,
            auditoria: {
                usuario: getUsuario().id,
                modulo: props.modulo,
                controle: linha.id,
                acao: ACOES.ENVIO_LOTE
            }
        }, true, true)).then(x => {
            target.current.atualizar();
            mostrarToast('sucesso', mensagens['sucesso']);
        }).catch(x => {
            mostrarToast('erro', mensagens['erro'])
        })
    }

    const OutrasAcoes = ({ propsAcao, ...props }) => {
        return (
            <Dropdown className="testando-aqui">
                <DropdownTrigger>
                    <Btn icone='icon-ellipsi' texto="Mais Ações" />
                </DropdownTrigger>
                <DropdownContent>
                    <div className="card-acoes-dropdown">
                        <div className="ajusta-dropdown-consulta-guia">
                            {[
                                propsAcao.row.data_devolucao === null && (propsAcao.row.status_id && propsAcao.row.status_id === 1) ? <BtnAcaoModal titulo='Cadastro de Entrega ao Destinatário(Devolução de Comprovante de Anestesia)' showModal={showModal} modal={<CadastroModalDevolucao propsAcao={propsAcao} modal="true" setShow={setShowModal} funcaoAposSalvar={() => { target.current.atualizar(); setShowModal(false); }}></CadastroModalDevolucao>} classeContent="ml-1-between" icone="icon-Remove-Cart" texto="Entrega" action={_ => { setShowModal(true) }} {...props} /> : <></>,
                                propsAcao.row.data_devolucao === null && (propsAcao.row.status_id && propsAcao.row.status_id === 1) ? <BtnAcaoConfirmacao classeContent="ml-1-between" icone="icon-Paper-Plane" texto="Enviar Lote" action={(loadingAct, setLoadingAct) => { setLinhaConsulta(propsAcao.row); validarDevolucaoLote(propsAcao.row, setLoadingAct) }} mensagem={"Confirmar envio"} {...props} /> : <></>,
                                <BtnAcao classeContent="ml-1-between" icone="icon-Download-fromCloud" texto="Baixar Arquivos" action={_ => baixarArquivos(propsAcao.row)} {...props} />,
                                !(propsAcao.row.data_devolucao === null) ? <BtnAcaoLink to={{ pathname: '/relatorios/devolucao/lote', state: { id_devolucao: propsAcao.id } }} classeContent="ml-1-between" icone="icon-File-HorizontalText" texto="Relatório" action={_ => { }} {...props} /> : <></>,
                                propsAcao.row.status_id && propsAcao.row.status_id !== 1 ? <BtnAcaoModal titulo='Cancelamento de Devolução' showModal={showModalCancelamento} modal={<CadastroCancelamentoDevolucao propsAcao={propsAcao} modal="true" setShow={setShowModalCancelamento} funcaoAposSalvar={() => { target.current.atualizar(); setShowModalCancelamento(false); }}></CadastroCancelamentoDevolucao>} classeContent="ml-1-between" icone="icon-Close-Window" texto="Cancelamento" action={_ => { setShowModalCancelamento(true) }} {...props} /> : <></>
                            ]}
                        </div>
                    </div>
                </DropdownContent>
            </Dropdown>
        )
    }
    const baixarArquivos = async (linha) => {
        const toastify = toast(`Preparando download para o lote ${linha.id}`, { isLoading: true, progress: 0 })
        const instance = obterInstancia();

        try {
            const response = await instance.get(URL_BACKEND + `/devolucao/baixarArquivos/${linha.id}`, {
                responseType: 'blob',
                params: {
                    auditoria: {
                        usuario: getUsuario().id,
                        modulo: props.modulo,
                        controle: linha.id,
                        acao: ACOES.DOWNLOAD
                    }
                }
            });

            const blob = new Blob([response.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = `Comprovantes_${linha.id}.zip`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            mostrarToast('sucesso', mensagens['sucesso']);
        } catch (error) {
            mostrarToast('erro', mensagens['erro'])
        } finally {
            toast.dismiss(toastify);
        }
    }

    const maisAcoesObj = [
        propsAcao => propsAcao.row.data_devolucao === null ? <Alterar to={'/devolucao/lote/alteracao/' + propsAcao.id} /> : <></>,
        propsAcao => propsAcao.row.data_devolucao === null ? <Excluir to={'/devolucao/lote/consulta/'} action={() => exclusao(propsAcao)} /> : <></>,
        propsAcao => <Visualizar to={'/devolucao/lote/visualizacao/' + propsAcao.id} />,
        propsAcao => <OutrasAcoes propsAcao={propsAcao} />
    ]

    return (
        <>
            <div>
                <DataGridAlternativa alinhamentoAcoes='text-center' ref={target} data={data} columns={columns} setData={setData} acoes={true} caminhoBase='/devolucao/lote' modulo={props.modulo} titulo={'Consulta Devolução Comprovante de Anestesia'}
                    tituloLista={'Lista Devolução Comprovante de Anestesia'} acoesObj={maisAcoesObj}
                    urlCadastro='/devolucao/lote/cadastro' icone={'icon-File-ClipboardFileText'} caminhoConsultaFiltros='/devolucao/lotepaginacao' />
                <ModalDuasOpcoes showModal={showValidacao} setShowModal={setShowValidacao} funcaoOpcao2={_ => { enviarDevolucao(linhaConsulta); setShowValidacao(false) }} funcaoOpcao1={_ => { setShowValidacao(false); setLinhaConsulta(null) }}
                    esconderFechar mensagem={msgValidacao}
                    textoOpcao1={'Cancelar'}
                    classeOpcao1={'btn-sm btn-primary-modal simples'}
                    textoOpcao2={'Continuar'} />
            </div>
        </>
    )
}